"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = exports.DealerLocator = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _geolib = _interopRequireDefault(require("geolib"));
var _react = _interopRequireDefault(require("react"));
var _clsx3 = _interopRequireDefault(require("clsx"));
var _aboveTheFoldOnlyServerRender = require("above-the-fold-only-server-render");
var _reactDom = _interopRequireDefault(require("react-dom"));
var _reactRedux = require("react-redux");
var _searchDealerships = _interopRequireDefault(require("./search-dealerships"));
var _googleMap = _interopRequireDefault(require("./google-map"));
var _constants = require("../constants");
var _dealerLocator = _interopRequireDefault(require("../styles/dealer-locator.css"));
var _types = _interopRequireDefault(require("./types"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var DealerLocator = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(DealerLocator, _React$Component);
  DealerLocator.shouldUseData = function shouldUseData(_ref) {
    var data = _ref.data,
      newDealerList = _ref.dealerList;
    return data.searchDealer ? data.searchDealer : newDealerList;
  };
  DealerLocator.extendableDealerListObjectsArray = function extendableDealerListObjectsArray(dealers) {
    if (dealers && dealers.length > 0) {
      return dealers.map(function (dealer) {
        return _objectSpread({}, dealer);
      });
    }
  };
  function DealerLocator(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      dealerShipType: 'all',
      hoveredDealer: undefined,
      hoveredPin: undefined,
      mobileShowMap: true,
      searching: false,
      noDealersFound: false,
      hasLoaded: false
    };
    _this.updateDealerShipType = _this.updateDealerShipType.bind((0, _assertThisInitialized2["default"])(_this));
    _this.updateHoveredDealer = _this.updateHoveredDealer.bind((0, _assertThisInitialized2["default"])(_this));
    _this.updateHoveredPin = _this.updateHoveredPin.bind((0, _assertThisInitialized2["default"])(_this));
    _this.updateMobileShowMap = _this.updateMobileShowMap.bind((0, _assertThisInitialized2["default"])(_this));
    _this.updateUserLocation = _this.updateUserLocation.bind((0, _assertThisInitialized2["default"])(_this));
    _this.scrollToTop = _this.scrollToTop.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onPlaceChange = _this.onPlaceChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onSearchStart = _this.onSearchStart.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onSearchEnd = _this.onSearchEnd.bind((0, _assertThisInitialized2["default"])(_this));
    _this.toggleGeoCodeError = _this.toggleGeoCodeError.bind((0, _assertThisInitialized2["default"])(_this));
    _this.searchInnerContainer = /*#__PURE__*/_react["default"].createRef();
    return _this;
  }
  var _proto = DealerLocator.prototype;
  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var noDealersFound = this.state.noDealersFound;
    if (prevState['noDealersFound'] !== noDealersFound) {
      var dealerExists = this.hasDealers();
      this.setState({
        noDealersFound: !dealerExists
      });
    }
  };
  _proto.onPlaceChange = function onPlaceChange(map) {
    if (this.searchInnerContainer && this.searchInnerContainer.current) {
      this.searchInnerContainer.current.onPlaceChange(map);
    }
  };
  _proto.onSearchStart = function onSearchStart() {
    this.setState({
      searching: true,
      noDealersFound: false
    });
  };
  _proto.onSearchEnd = function onSearchEnd() {
    this.setState({
      searching: false,
      hasLoaded: true
    });
  };
  _proto.hasDealers = function hasDealers() {
    var data = this.props.data;
    return Array.isArray(data.searchDealer) && data.searchDealer.length > 0;
  };
  _proto.refineDealerList = function refineDealerList(list, tagged) {
    var _this2 = this;
    if (list && list.length > 0) {
      if (tagged) {
        return list.map(function (el) {
          return _this2.formatDealer(el);
        }).sort(function (a, b) {
          return a.distance - b.distance;
        }).map(function (el, i) {
          return _objectSpread(_objectSpread({}, el), {}, {
            pinLabel: _constants.markerLabels[i]
          });
        });
      }
      return list.map(function (el) {
        return _this2.formatDealer(el);
      }).sort(function (a, b) {
        return a.distance - b.distance;
      }).map(function (el) {
        return _objectSpread(_objectSpread({}, el), {}, {
          pinLabel: ''
        });
      });
    }
  };
  _proto.updateHoveredDealer = function updateHoveredDealer(dealer) {
    return this.setState({
      hoveredDealer: dealer
    });
  };
  _proto.updateHoveredPin = function updateHoveredPin(pin) {
    return this.setState({
      hoveredPin: pin
    });
  };
  _proto.updateDealerShipType = function updateDealerShipType(selectedType) {
    var _this3 = this;
    var userLocation = this.props.userLocation;
    var dealerShipType = this.state.dealerShipType;
    // Push data for MKS
    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push({
        event: 'dealer-locator-drop-down',
        searchType: selectedType
      });
    }
    return this.setState(function () {
      return {
        dealerShipType: selectedType
      };
    }, function () {
      _this3.updateUserLocation(userLocation, dealerShipType);
    });
  };
  _proto.updateMobileShowMap = function updateMobileShowMap(bool) {
    return this.setState({
      mobileShowMap: bool
    });
  };
  _proto.toggleGeoCodeError = function toggleGeoCodeError() {
    this.setState({
      searching: false
    });
  };
  _proto.updateUserLocation = function updateUserLocation(location) {
    var updateDealership = this.props.updateDealership;
    var dealerShipType = this.state.dealerShipType;
    return updateDealership(location, dealerShipType);
  };
  _proto.scrollToTop = function scrollToTop() {
    var selectedDealer = this.props.selectedDealer;
    var node = this.searchInnerContainer.current;
    if (node !== null && selectedDealer) {
      // eslint-disable-next-line react/no-find-dom-node
      _reactDom["default"].findDOMNode(node).scrollIntoView(true);
    }
  };
  _proto.formatDealer = function formatDealer(dealer) {
    var _this$props = this.props,
      userLocation = _this$props.userLocation,
      measurementSystem = _this$props.measurementSystem;
    var mutatedWithDummyDataDealer = _objectSpread({}, dealer);

    // Add Distance from Dealer to Entered Location
    var distance = _geolib["default"].getDistance({
      latitude: userLocation.lat,
      longitude: userLocation.lng
    }, {
      latitude: dealer.address.latitude,
      longitude: dealer.address.longitude
    }) / 1000;
    if (measurementSystem === 'imperial') {
      // calculate distance in miles in markets with miles
      var convertKMToMiles = function convertKMToMiles(distanceInKM) {
        distance = distanceInKM / 1.609344;
      };
      convertKMToMiles(distance);
    }
    mutatedWithDummyDataDealer = _objectSpread(_objectSpread({}, mutatedWithDummyDataDealer), {}, {
      distance: parseFloat(distance.toFixed(2))
    });
    return mutatedWithDummyDataDealer;
  };
  _proto.render = function render() {
    var _clsx, _clsx2;
    var _this$props2 = this.props,
      defaultLocation = _this$props2.defaultLocation,
      theme = _this$props2.theme,
      path = _this$props2.path,
      loading = _this$props2.loading,
      googleAPIKeyFromConfig = _this$props2.googleAPIKeyFromConfig,
      googleMapSettings = _this$props2.googleMapSettings,
      selectedDealer = _this$props2.selectedDealer,
      updateSelectedDealer = _this$props2.updateSelectedDealer,
      updateMapCentre = _this$props2.updateMapCentre,
      updateStateCode = _this$props2.updateStateCode,
      userLocation = _this$props2.userLocation,
      setInitialMapGeocodeFromCountryCode = _this$props2.setInitialMapGeocodeFromCountryCode,
      isInitialMapLoad = _this$props2.isInitialMapLoad,
      showList = _this$props2.showList,
      radius = _this$props2.radius,
      defaultRadius = _this$props2.defaultRadius,
      setSearchValue = _this$props2.setSearchValue,
      searchValue = _this$props2.searchValue,
      pageData = _this$props2.pageData,
      handlePlacesChangedEvent = _this$props2.handlePlacesChangedEvent,
      placeChanged = _this$props2.placeChanged,
      setIsInitialMapLoad = _this$props2.setIsInitialMapLoad,
      market = _this$props2.market,
      language = _this$props2.language,
      languageDirectionMap = _this$props2.languageDirectionMap,
      skipServerRendering = _this$props2.skipServerRendering;
    var dealers = DealerLocator.shouldUseData(this.props);
    var dealerList = DealerLocator.extendableDealerListObjectsArray(dealers);
    var refinedDealerList = this.refineDealerList(dealerList, !isInitialMapLoad);
    var formattedSelectedDealer = selectedDealer && selectedDealer.distance === undefined ? this.formatDealer(selectedDealer) : selectedDealer;
    var carServiceCTA = pageData.carServiceCTA,
      contactLabel = pageData.contactLabel,
      locationCtaLabel = pageData.locationCtaLabel,
      saleOpeningHoursLabel = pageData.saleOpeningHoursLabel,
      salesSearchFilterLabel = pageData.salesSearchFilterLabel,
      searchHelpText = pageData.searchHelpText,
      searchResultsFoundLabel = pageData.searchResultsFoundLabel,
      serviceOpeningHoursLabel = pageData.serviceOpeningHoursLabel,
      serviceSearchFilterLabel = pageData.serviceSearchFilterLabel,
      allDealershipsSearchFilterLabel = pageData.allDealershipsSearchFilterLabel,
      showRating = pageData.showRating,
      testDriveCTA = pageData.testDriveCTA,
      title = pageData.title,
      noGeolocationMessage = pageData.noGeolocationMessage,
      noDealershipFoundMessage = pageData.noDealershipFoundMessage,
      listLabel = pageData.listLabel,
      mapLabel = pageData.mapLabel,
      mapOverlayImage = pageData.mapOverlayImage,
      headingTag = pageData.headingTag,
      zoomLevel = pageData.zoomLevel,
      searchInventoryLabel = pageData.searchInventoryLabel,
      scheduleServiceLabel = pageData.scheduleServiceLabel,
      contactUsLabel = pageData.contactUsLabel,
      clickShopCTA = pageData.clickShopCTA,
      clickshopParamters = pageData.clickshopParamters,
      serviceWebsiteCTALabel = pageData.serviceWebsiteCTALabel,
      contactSectionOnTop = pageData.contactSectionOnTop;
    var _this$state = this.state,
      dealerShipType = _this$state.dealerShipType,
      distanceInMiles = _this$state.distanceInMiles,
      hoveredDealer = _this$state.hoveredDealer,
      hoveredPin = _this$state.hoveredPin,
      mobileShowMap = _this$state.mobileShowMap,
      searching = _this$state.searching,
      hasLoaded = _this$state.hasLoaded,
      noDealersFound = _this$state.noDealersFound;
    var _languageDirectionMap = languageDirectionMap.find(function (el) {
        return el.language === language;
      }),
      _languageDirectionMap2 = _languageDirectionMap.direction,
      languageDirection = _languageDirectionMap2 === void 0 ? 'ltr' : _languageDirectionMap2;
    var isLoadingOrSearching = loading || searching;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx3["default"])(theme.lock_LTR, _dealerLocator["default"].appContainer, (_clsx = {}, _clsx[_dealerLocator["default"].imageOverlayLayout] = mapOverlayImage, _clsx[_dealerLocator["default"].hasLoaded] = hasLoaded, _clsx[_dealerLocator["default"].loadingNoEvents] = isLoadingOrSearching, _clsx))
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx3["default"])(_dealerLocator["default"].loader, (_clsx2 = {}, _clsx2[_dealerLocator["default"].isLoading] = isLoadingOrSearching, _clsx2))
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: _dealerLocator["default"].consoleContainer,
      dir: languageDirection
    }, /*#__PURE__*/_react["default"].createElement(_searchDealerships["default"], {
      ref: this.searchInnerContainer,
      headingTag: headingTag,
      carServiceCTA: carServiceCTA,
      contactLabel: contactLabel,
      currentLocation: userLocation,
      dealerList: refinedDealerList,
      defaultLocation: defaultLocation,
      distanceInMiles: distanceInMiles,
      hoveredDealer: hoveredDealer,
      hoveredPin: hoveredPin,
      clickShopCTA: clickShopCTA,
      clickshopParamters: clickshopParamters,
      locationCtaLabel: locationCtaLabel,
      mobileShowMap: mobileShowMap,
      saleOpeningHoursLabel: saleOpeningHoursLabel,
      salesSearchFilterLabel: salesSearchFilterLabel,
      searchHelpText: searchHelpText,
      searchResultsFoundLabel: searchResultsFoundLabel,
      selectedDealer: formattedSelectedDealer,
      selectedType: dealerShipType,
      serviceOpeningHoursLabel: serviceOpeningHoursLabel,
      serviceSearchFilterLabel: serviceSearchFilterLabel,
      allDealershipsSearchFilterLabel: allDealershipsSearchFilterLabel,
      showRating: showRating,
      testDriveCTA: testDriveCTA
      // clickShopButton={clickShopButton}
      // clickshopParamters={clickshopParamters}
      ,
      onSearchStart: this.onSearchStart,
      onSearchEnd: this.onSearchEnd,
      theme: theme,
      title: title,
      pageData: pageData,
      updateDealerShipType: this.updateDealerShipType,
      updateHoveredDealer: this.updateHoveredDealer,
      updateMapCentre: updateMapCentre,
      updateStateCode: updateStateCode,
      updateMobileShowMap: this.updateMobileShowMap,
      updateSelectedDealer: updateSelectedDealer,
      updateUserLocation: this.updateUserLocation,
      showList: showList,
      radius: radius,
      defaultRadius: defaultRadius,
      setSearchValue: setSearchValue,
      searchValue: searchValue,
      isInitialMapLoad: isInitialMapLoad,
      noDealersFound: noDealersFound,
      noGeolocationMessage: noGeolocationMessage,
      noDealershipFoundMessage: noDealershipFoundMessage,
      handlePlacesChangedEvent: handlePlacesChangedEvent,
      placeChanged: placeChanged,
      scrollToTop: this.scrollToTop,
      toggleGeoCodeError: this.toggleGeoCodeError,
      setIsInitialMapLoad: setIsInitialMapLoad,
      setInitialMapGeocodeFromCountryCode: setInitialMapGeocodeFromCountryCode,
      market: market,
      listLabel: listLabel,
      mapLabel: mapLabel,
      languageDirection: languageDirection,
      searchInventoryLabel: searchInventoryLabel,
      scheduleServiceLabel: scheduleServiceLabel,
      contactUsLabel: contactUsLabel,
      path: path,
      serviceWebsiteCTALabel: serviceWebsiteCTALabel,
      contactSectionOnTop: contactSectionOnTop
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: _dealerLocator["default"].mapContainer + " " + (mobileShowMap ? '' : _dealerLocator["default"].hiddenContainer)
    }, typeof dealers !== 'undefined' && /*#__PURE__*/_react["default"].createElement(_aboveTheFoldOnlyServerRender.AboveTheFoldOnlyServerRender, {
      skip: skipServerRendering
    }, /*#__PURE__*/_react["default"].createElement(_googleMap["default"], {
      newApiKey: googleAPIKeyFromConfig,
      defaultLocation: defaultLocation,
      selectedDealer: formattedSelectedDealer,
      refinedDealerList: refinedDealerList,
      dealerList: refinedDealerList,
      googleMapSettings: googleMapSettings,
      userLocation: userLocation,
      hoveredDealer: hoveredDealer,
      updateHoveredDealer: this.updateHoveredDealer,
      updateHoveredPin: this.updateHoveredPin,
      updateSelectedDealer: updateSelectedDealer,
      hoveredPin: hoveredPin,
      onPlaceChange: this.onPlaceChange,
      setInitialMapGeocodeFromCountryCode: setInitialMapGeocodeFromCountryCode,
      isInitialMapLoad: isInitialMapLoad,
      handlePlacesChangedEvent: handlePlacesChangedEvent,
      placeChanged: placeChanged,
      selectedType: dealerShipType,
      zoomLevel: zoomLevel,
      region: market,
      language: language
    })), mapOverlayImage && /*#__PURE__*/_react["default"].createElement("div", {
      className: _dealerLocator["default"].imageOverlayWrapper
    }, mapOverlayImage)));
  };
  return DealerLocator;
}(_react["default"].Component);
exports.DealerLocator = DealerLocator;
DealerLocator.displayName = 'DealerLocator';
DealerLocator.defaultProps = {
  skipServerRendering: true
};
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    market: props.market || state.Config.market,
    measurementSystem: props.measurementSystem || state.Config.measurementSystem,
    googleAPIKeyFromConfig: props.googleApiKey || state.Config.googleApiKey,
    language: props.language || state.Config.language,
    languageDirectionMap: props.languageDirectionMap || state.Config.languageDirectionMap
  };
};
var _default = (0, _reactRedux.connect)(mapStateToProps)(DealerLocator);
exports["default"] = _default;